import { AXON_BRACKET_COLOR } from "../constants";

interface Props {
  size?: number;
  className?: string;
}

const ASPECT = 34.7788 / 55.210228;

export function InguzMark({ size = 22, className }: Props) {
  return (
    <svg
      viewBox="0 0 34.7788 55.210228"
      width={Math.round(size * ASPECT)}
      height={size}
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <path
        d="M 26.87406,1.048e-4 0.614991,25.395985 C 0.358684,25.645274 0.150234,25.939479 0,26.263911 v 2.470901 c 0.147243,0.318319 0.350515,0.607599 0.600131,0.854001 l 26.125765,25.621415 h 7.760396 l 0.292337,-0.298111 v -9.29e-4 L 32.689389,52.863039 6.8411171,27.513923 33.009746,2.2054781 34.778629,0.4965005 V 0 Z"
        fill="currentColor"
      />
      <path
        d="M 7.9046981,1.048e-4 34.163811,25.395985 c 0.256253,0.249289 0.4647,0.543494 0.614988,0.867926 v 2.470901 c -0.14723,0.318319 -0.3505,0.607599 -0.600128,0.854001 L 8.0528531,55.210228 H 0.292438 L 1.04e-4,54.912117 v -9.29e-4 L 2.089367,52.863124 27.937613,27.514008 1.768969,2.205529 1.04e-4,0.496553 V 0 Z"
        fill={AXON_BRACKET_COLOR}
      />
    </svg>
  );
}
